const menuOpen = document.getElementById('js-OpenMenu');
const menuContainer = document.getElementById('js-container');
const menuList = document.querySelector('.menu__nav__list');
const spanElement = menuOpen.querySelector("span");
const headerElement = document.querySelector('header');
const headerContent = document.querySelector('.header__content');

function offset(el) {
    let rect = el.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}

if (window.innerWidth > 960) {
    window.addEventListener('scroll', function() {
        if (window.innerWidth <= 1200 && window.scrollY > 335) {
            headerElement.classList.add('header--fixed');
        } else if (window.innerWidth > 1200 && window.scrollY > 400) {
            headerElement.classList.add('header--fixed');
        } else {
            headerElement.classList.remove('header--fixed');
            // Supprimer les classes si l'élément header n'a plus la classe header--fixed
            menuContainer.classList.remove('visible-container');
            headerContent.classList.remove('overlay-fixed');
            menuList.classList.remove('animation');
            spanElement.classList.remove('span-close');
            headerElement.classList.remove('header-opacity');
        }
    });
}

// Au clic sur le bouton "Menu" en header--fixed
menuOpen.addEventListener('click', function() {
    // Vérifie si l'élément header possède la classe .header--fixed
    if (headerElement.classList.contains('header--fixed')) {
        //Rend visible le menu
        menuContainer.classList.toggle('visible-container');
        //Gère le fond du menu
        headerContent.classList.toggle('overlay-fixed');
        //Gère l'apparition des premières entrées du menu pour qu'elle apparaissent après le fond 
        menuList.classList.toggle('animation');
        //Gère l'animation du btn burger Menu
        spanElement.classList.toggle('span-close');
        //Change la couleur de fond pour le header fixe{
        headerElement.classList.toggle('header-opacity');
    }
});